import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ITaskTypeCategory } from '@common/interfaces/issueTypeWorflow';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '@ep-om/project/state/action/action.service';
import { CrudService } from '@ep-om/project/state/crudService';
import { TaskTypeCategoryQuery } from '@ep-om/project/state/taskTypeCategory/taskTypeCategory.query';
import { TaskTypeCategoryStore } from '@ep-om/project/state/taskTypeCategory/taskTypeCategory.store';
import { BaseEntityStoreStrategy } from '@ep-om/project/state/updateStoreStrategies';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TaskTypeCategoryService extends CrudService<ITaskTypeCategory, TaskTypeCategoryStore, TaskTypeCategoryQuery> {
  private readonly baseUrl = `${environment.apiUrl}/api/typecategories`;

  constructor(
    public store: TaskTypeCategoryStore,
    public query: TaskTypeCategoryQuery,
    protected updateStrategy: BaseEntityStoreStrategy,
    protected actionService: ActionService,
    private http: HttpClient) {
    super(
      Topics.TYPE_CATEGORY,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

  loadNonDeletedCategories(): Observable<ITaskTypeCategory[]> {
    return this.http.get<ITaskTypeCategory[]>(this.baseUrl).pipe(
      tap((categories) => this.store.set(categories ?? [])),
      catchError((error) => {
        console.error('Failed to load type categories', error);
        this.store.set([]);
        return of([]);
      })
    );
  }
}
